import { HttpClient, HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';

import { CmsServerService } from 'src/app/services/jsonrpc/cms-server.service';

import { FileUploadComponent } from '../file-upload/file-upload.component';

@Component({
  selector: 'app-logo-exchange',
  templateUrl: './logo-exchange.component.html',
  styleUrls: ['./logo-exchange.component.scss']
})
export class LogoExchangeComponent {
  @Output() public upload = new EventEmitter<any>();

  @ViewChild(FileUploadComponent) private fileUpload: FileUploadComponent;

  public uploading = false;
  public uploadProgress = {};
  public logoUrl = 'public/logo.png';

  public imageFormats = {
    'image/png': 'image',
    'image/jpeg': 'image'
  };

  constructor(private server: CmsServerService, private http: HttpClient) {}

  public uploadLogo(files: { title: string; file: File }[]) {
    // check whether only one file can get uploaded
    const file = files[0].file;
    const reader = new FileReader();

    this.uploading = true;

    reader.readAsDataURL(file);
    reader.onload = async () => {
      await this.loadScaleAndCenterImage(reader.result as string).then((data: string) => {
        const dataFile = new File([this.dataURItoBlob(data)], 'logo.png');

        return this.server.mediaPublicUpload({ filename: 'logo.png' }).then(res =>
          new Promise((resolve, reject) => {
            this.http
              .put(res.url, dataFile, {
                reportProgress: true,
                observe: 'events'
              })
              .subscribe(
                ev => {
                  if (ev.type == HttpEventType.Response) {
                    return setTimeout(() => resolve({ url: res.url, file: file }), 1500);
                  } else if (ev.type == HttpEventType.UploadProgress) {
                    this.uploadProgress[files[0].title] = Math.round((ev.loaded / ev.total) * 100);
                  }
                },
                err => reject(err)
              );
          }).then((resolved: any) => {
            this.logoUrl = resolved.url.split('?')[0];
            this.cleanFileUpload();
          })
        );
      });
    };
  }

  private loadScaleAndCenterImage(imageUrl: any): Promise<any> {
    return new Promise(resolve => {
      const image = new Image();

      image.onload = () => {
        const canvas = document.createElement('canvas');

        const ctxWidth = 800;
        const ctxHeight = 480;

        const ratioWidth = image.width / ctxWidth;
        const ratioHeight = image.height / ctxHeight;

        const ratioAspect = ratioWidth > 1 ? ratioWidth : ratioHeight > 1 ? ratioHeight : 1;

        const newWidth = image.width / ratioAspect;
        const newHeight = image.height / ratioAspect;

        const offsetX = ctxWidth / 2 - newWidth / 2;
        const offsetY = ctxHeight / 2 - newHeight / 2;

        canvas.width = ctxWidth;
        canvas.height = ctxHeight;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, image.width, image.height, offsetX, offsetY, newWidth, newHeight);

        const data = canvas.toDataURL('image/png', 1);

        resolve(data);
      };

      image.src = imageUrl;
    });
  }

  public cleanFileUpload() {
    this.uploadProgress = {};
    this.uploading = false;
    this.fileUpload.reset();
  }

  // I'm stolen from the internet, please ignore me
  private dataURItoBlob(dataURI) {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: mimeString });
    return blob;
  }
}
